import { render, staticRenderFns } from "./MiniCardComponent.vue?vue&type=template&id=36af13de&scoped=true&"
import script from "./MiniCardComponent.vue?vue&type=script&lang=ts&"
export * from "./MiniCardComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MiniCardComponent.vue?vue&type=style&index=0&id=36af13de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af13de",
  null
  
)

export default component.exports